module.exports = __webpack_public_path__ + "static/media/Hostinger.0565686d.svg";